import i18n from "../../services/localization-service/i18n";
import { FormRadioGroupRadioButton } from "../forms/form-radio-group/FormRadioGroup";


export enum DurationOptionEnum {
    Custom = -1,
    Default = 0,
    OneDay = 1,
    ThreeDays = 3,
    SevenDays = 7,
    ThirtyDays = 30
}

export const durationRadioButtons: FormRadioGroupRadioButton[] = [{
    label: i18n.t('customDuration.last250'),
    ariaLabel: 'last 250 values',
    value: DurationOptionEnum.Default.toString()
},{
    label: i18n.t('customDuration.1Day'),
    ariaLabel: '1 day',
    value: DurationOptionEnum.OneDay.toString()
},{
    label: i18n.t('customDuration.3Days'),
    ariaLabel: '3 days',
    value: DurationOptionEnum.ThreeDays.toString()
},{
    label: i18n.t('customDuration.7Days'),
    ariaLabel: '7 days',
    value: DurationOptionEnum.SevenDays.toString()
},{
    label: i18n.t('customDuration.30Days'),
    ariaLabel: '30 days',
    value: DurationOptionEnum.ThirtyDays.toString()
},{
    label: i18n.t('customDuration.custom'),
    ariaLabel: 'custom duration',
    value: DurationOptionEnum.Custom.toString()
}];



const CustomDurationUtils = {
    getCustomDurationLabel(option: DurationOptionEnum, valueOnly?: boolean): string {

        switch(option) {

            case DurationOptionEnum.OneDay:
                return valueOnly ? `${i18n.t('customDuration.1Day')}` : `${i18n.t('customDuration.duration')}: ${i18n.t('customDuration.1Day')}`;

            case DurationOptionEnum.ThreeDays:
                return valueOnly ? `${i18n.t('customDuration.3Days')}` : `${i18n.t('customDuration.duration')}: ${i18n.t('customDuration.3Days')}`;

            case DurationOptionEnum.SevenDays:
                return valueOnly ? `${i18n.t('customDuration.7Days')}` : `${i18n.t('customDuration.duration')}: ${i18n.t('customDuration.7Days')}`;

            // case DurationOptionEnum.TenDays:
            //     return valueOnly ? `${i18n.t('customDuration.10Days')}` : `${i18n.t('customDuration.duration')}: ${i18n.t('customDuration.10Days')}`;

            case DurationOptionEnum.ThirtyDays:
                return valueOnly ? `${i18n.t('customDuration.30Days')}` : `${i18n.t('customDuration.duration')}: ${i18n.t('customDuration.30Days')}`;

            case DurationOptionEnum.Custom:
                return valueOnly ? `${i18n.t('customDuration.custom1')}` : `${i18n.t('customDuration.duration')}: ${i18n.t('customDuration.custom1')}`;

            default:
                return valueOnly ? `${i18n.t('customDuration.last250')}` : `${i18n.t('customDuration.duration')}: ${i18n.t('customDuration.last250')}`;
        }
    }

};

export default CustomDurationUtils;
